module.exports = __webpack_public_path__ + "static/media/entrance.eee808d3.jpg";